import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "button-icon" }
const _hoisted_2 = { class: "button-label" }

import type { Component } from 'vue';

import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';

import * as nativex from '@native';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExploreButton',
  props: {
    icon: {},
    label: {},
    to: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function onClick(event: MouseEvent) {
  nativex.playTouchSound();
  if (!props.to) event.preventDefault();
  emit('click', event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.to ? 'router-link' : 'a'), _mergeProps({ class: "explore-button" }, __props.to ? { to: __props.to } : { href: '#', role: 'button' }, {
    "aria-label": __props.label,
    onClick: onClick
  }), {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), { size: 20 }))
      ]),
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1),
      _createVNode(ChevronRightIcon, {
        class: "button-chevron",
        size: 18
      })
    ]),
    _: 1
  }, 16, ["aria-label"]))
}
}

})